import { render, staticRenderFns } from "./sunbed.form.vue?vue&type=template&id=40316aa1&"
import script from "./sunbed.form.vue?vue&type=script&lang=js&"
export * from "./sunbed.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports